import { getDroplink } from '@/shared/param-utils';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { IconCtaLeftAlignedCardProps } from '@ahc-digital/component-library';
import { C33IconCTALeftAlignedCardProps } from './C33IconCTALeftAlignedCard.types';
import { getKvpValue } from '@/shared/field-utils';

export function CreateIconCTALeftAlignedCardModel(
  props?: C33IconCTALeftAlignedCardProps
): IconCtaLeftAlignedCardProps {
  type t = IconCtaLeftAlignedCardProps;
  const { params, fields } = props || {};
  const { renderRichText, renderText, renderLink } = useConditionalRendering();

  return {
    icon: getKvpValue<t['icon']>(fields?.Icon),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    cardCTA: renderLink(fields?.CardCTA),
  };
}
